import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 199C908D-09C4-47C6-968A-74582AC4AF26
 * name arrow-left-drop-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-drop-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftDropCircleIcon = createSvgIcon(<><path d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M14,7L9,12L14,17V7Z" /></>, 'ArrowLeftDropCircleIcon');
export default ArrowLeftDropCircleIcon